'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

var _slicedToArray = function () {
  function sliceIterator(arr, i) {
    var _arr = [];
    var _n = true;
    var _d = false;
    var _e = undefined;

    try {
      for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
        _arr.push(_s.value);

        if (i && _arr.length === i) break;
      }
    } catch (err) {
      _d = true;
      _e = err;
    } finally {
      try {
        if (!_n && _i["return"]) _i["return"]();
      } finally {
        if (_d) throw _e;
      }
    }

    return _arr;
  }

  return function (arr, i) {
    if (Array.isArray(arr)) {
      return arr;
    } else if (Symbol.iterator in Object(arr)) {
      return sliceIterator(arr, i);
    } else {
      throw new TypeError("Invalid attempt to destructure non-iterable instance");
    }
  };
}();

var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactDropzone = require('react-dropzone');

var _reactDropzone2 = _interopRequireDefault(_reactDropzone);

var _Input = require('../Input/Input');

var _Input2 = _interopRequireDefault(_Input);

var _Button = require('../Button/Button');

var _Button2 = _interopRequireDefault(_Button);

var _Container = require('./components/Container');

var _Container2 = _interopRequireDefault(_Container);

var _InputContainer = require('./components/InputContainer');

var _InputContainer2 = _interopRequireDefault(_InputContainer);

var _ButtonContainer = require('./components/ButtonContainer');

var _ButtonContainer2 = _interopRequireDefault(_ButtonContainer);

var _styles = require('./styles');

var _styles2 = _interopRequireDefault(_styles);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _objectWithoutProperties(obj, keys) {
  var target = {};

  for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
    target[i] = obj[i];
  }

  return target;
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
} // Components
// Styles


var FileInput = function (_Component) {
  _inherits(FileInput, _Component);

  function FileInput() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, FileInput);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = FileInput.__proto__ || Object.getPrototypeOf(FileInput)).call.apply(_ref, [this].concat(args))), _this), _this.onFile = function (_ref2) {
      var _ref3 = _slicedToArray(_ref2, 1),
          file = _ref3[0];

      if (!file) return;

      _this.props.onChange(file);
    }, _this.onChange = function () {}, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(FileInput, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          file = _props.file,
          accept = _props.accept,
          onChange = _props.onChange,
          loading = _props.loading,
          children = _props.children,
          lookup = _props.lookup,
          props = _objectWithoutProperties(_props, ['file', 'accept', 'onChange', 'loading', 'children', 'lookup']);

      return _react2.default.createElement(_Container2.default, null, _react2.default.createElement(_reactDropzone2.default, {
        onDrop: this.onFile,
        accept: accept,
        multiple: false,
        style: _styles2.default.default,
        activeStyle: _styles2.default.active,
        acceptStyle: _styles2.default.accept,
        rejectStyle: _styles2.default.reject
      }, _react2.default.createElement(_InputContainer2.default, null, _react2.default.createElement(_Input2.default, _extends({}, props, {
        value: file || '',
        placeholder: 'Select a file',
        onChange: this.onChange,
        disabled: loading,
        postIcon: 'picture'
      }), children))), !!lookup && _react2.default.createElement(_ButtonContainer2.default, null, _react2.default.createElement('a', {
        href: lookup,
        target: '_blank',
        rel: 'noopener noreferrer'
      }, _react2.default.createElement(_Button2.default, {
        icon: 'eye',
        size: !!props.size ? props.size : 'normal',
        theme: 'grey'
      }))));
    }
  }]);

  return FileInput;
}(_react.Component);

FileInput.propTypes = {
  onChange: _propTypes2.default.func.isRequired,
  file: _propTypes2.default.string,
  accept: _propTypes2.default.string,
  lookup: _propTypes2.default.string,
  loading: _propTypes2.default.bool,
  children: _propTypes2.default.node
};
FileInput.defaultProps = {
  file: null,
  lookup: null,
  accept: 'application/pdf, image/*',
  loading: false
};
exports.default = FileInput;